import { render, staticRenderFns } from "./immediately.vue?vue&type=template&id=d68a228e&scoped=true"
import script from "./immediately.vue?vue&type=script&lang=js"
export * from "./immediately.vue?vue&type=script&lang=js"
import style0 from "./immediately.vue?vue&type=style&index=0&id=d68a228e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68a228e",
  null
  
)

export default component.exports